<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0258 34.7323C19.3505 34.8443 19.6752 34.9003 19.9999 34.9003C20.3246 34.9003 20.6521 34.8415 20.9824 34.724C21.3124 34.6065 21.6088 34.4303 21.8716 34.1953C23.3674 32.8172 24.767 31.4005 26.0703 29.9453C27.3737 28.4903 28.5041 27.0304 29.4616 25.5657C30.4188 24.1009 31.1778 22.6543 31.7387 21.2257C32.2995 19.7973 32.5799 18.4154 32.5799 17.0798C32.5799 13.2337 31.3359 10.12 28.8478 7.73859C26.3595 5.3572 23.4102 4.1665 19.9999 4.1665C16.5896 4.1665 13.6403 5.3572 11.152 7.73859C8.66395 10.12 7.41992 13.2337 7.41992 17.0798C7.41992 18.4154 7.70034 19.8001 8.26117 21.234C8.82201 22.6676 9.58381 24.1141 10.5466 25.5736C11.5091 27.033 12.642 28.4929 13.9453 29.9532C15.2489 31.4137 16.6485 32.8332 18.1441 34.2115C18.4069 34.4465 18.7008 34.6201 19.0258 34.7323ZM13.6707 22.9955C13.8959 23.2206 14.1691 23.3332 14.4905 23.3332H19.0473V20.2856H20.9521V23.3332H25.5088C25.8302 23.3332 26.1035 23.2206 26.3286 22.9955C26.5538 22.7702 26.6663 22.4969 26.6663 22.1756V17.2524C26.6663 16.9311 26.5538 16.6579 26.3286 16.4328C26.1035 16.2076 25.8302 16.0951 25.5088 16.0951H23.6187V11.1572C23.6187 10.8359 23.5061 10.5627 23.281 10.3376C23.0559 10.1124 22.7826 9.99984 22.4612 9.99984H17.5381C17.2168 9.99984 16.9435 10.1124 16.7183 10.3376C16.4932 10.5627 16.3806 10.8359 16.3806 11.1572V13.0475H14.4905C14.1691 13.0475 13.8959 13.16 13.6707 13.3852C13.4456 13.6103 13.333 13.8835 13.333 14.2048V22.1756C13.333 22.4969 13.4456 22.7702 13.6707 22.9955ZM16.3806 22.1903H14.4759V20.2856H16.3806V22.1903ZM16.3806 19.1427H14.4759V17.2379H16.3806V19.1427ZM16.3806 16.0951H14.4759V14.1903H16.3806V16.0951ZM19.4282 19.1427H17.5235V17.2379H19.4282V19.1427ZM19.4282 16.0951H17.5235V14.1903H19.4282V16.0951ZM19.4282 13.0475H17.5235V11.1427H19.4282V13.0475ZM22.4759 19.1427H20.5711V17.2379H22.4759V19.1427ZM22.4759 16.0951H20.5711V14.1903H22.4759V16.0951ZM22.4759 13.0475H20.5711V11.1427H22.4759V13.0475ZM25.5235 22.1903H23.6187V20.2856H25.5235V22.1903ZM25.5235 19.1427H23.6187V17.2379H25.5235V19.1427Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCity",
  props: {
    color: {
      default: "#ADADAD",
    },
  },
};
</script>

<style scoped></style>
